import { useContext } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { AdminContext } from '../../contexts/admin.context';
import { getFormErrorMessage } from '../../utils/formErrors';
import { getTranslation } from '../../utils/translation';
import Spinner from './Spinner';

export default function InputSelect({
  name,
  value,
  placeholder,
  className,
  containerClassName,
  label,
  subtext,
  error,
  touched,
  options,
  onChange,
  focus = true,
  isDark = false,
  loading = false,
  labelClassName = 'text-cblack-primary',
  textClassName = 'text-gray-primary',
  errorBaseKey = 'error',
  errorTranslationKey
}) {
  const { t } = useTranslation();
  const getErrorMessage = () => {
    return getFormErrorMessage({
      t,
      getTranslation,
      errorBaseKey,
      error,
      errorTranslationKey
    });
  };
  const errorMessage = touched && error ? getErrorMessage() : '';

  const {
    themeConfig: { buttonRadius }
  } = useContext(AdminContext);

  return (
    <div className={`mb-4 relative ${containerClassName}`}>
      {label && (
        <label
          className={`block mb-1 text-base font-bold ${labelClassName}`}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
      {subtext && (
        <p
          className="text-sm text-gray-primary mb-2 leading-5"
          dangerouslySetInnerHTML={{ __html: subtext }}
        />
      )}
      <select
        className={clsx(
          `px-4 py-3.5 w-full outline-none ${textClassName} text-base bg-gray-100 rounded-md ${className}`,
          {
            'bg-input': isDark
          },
          {
            'focus:ring-1': focus
          },
          {
            'focus:ring-black': focus
          },
          { 'bg-red-100': error }
        )}
        style={{ borderRadius: buttonRadius }}
        id={name}
        name={name}
        value={value}
        disabled={loading}
        onChange={(e) => onChange(e.target.value)}>
        {placeholder && <option value="">{placeholder}</option>}
        {options?.length > 0 &&
          options?.map((option, index) => (
            <option
              key={option.value || index}
              value={option.value}
              disabled={option.disabled}
              className="text-black">
              {option.label}
            </option>
          ))}
      </select>
      {errorMessage && <p className="ml-1 text-sm text-[#ef5252]">{errorMessage}</p>}

      {loading && (
        <div className="absolute left-0 top-0 w-full h-full flex items-center justify-center bg-white/50">
          <Spinner size={30} />
        </div>
      )}
    </div>
  );
}
